@if ((incomeTaxEntity$ | async) && isOndernemer) {
  <form [formGroup]="formGroup">
    @if (formGroup.controls.customInput.value === null) {
      <div class="row">
        <div class="col-7">
          <p>Wil je investeringaftrek specificeren of als bedrag invullen?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsCustomInput"
                                            class="custom-input-250"
                                            formControlName="customInput"
                                            id="customInput"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>
    } @else if (formGroup.controls.customInput.value) {
      <div class="row">
        <div class="col-7">
          <p>Wil je investeringaftrek specificeren of als bedrag invullen?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsCustomInput"
                                            class="custom-input-250"
                                            formControlName="customInput"
                                            id="customInput"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <p>Toe te passen bedrag van de investeringsaftrek in {{ (incomeTaxEntity$ | async)?.year }}</p>
        </div>
        <div class="col-5">
          <snelstart-ui-number-form-control [decimals]="0"
                                            (change)="saveForm()"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="toeTePassenInvesteringsaftrek"
                                            id="toeTePassenInvesteringsaftrek"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    } @else if (!formGroup.controls.customInput.value) {
      @if (investeringen.length > 0) {
        <div formArrayName="investeringen">
          @for (item of investeringen.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              [required]=true
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-select-form-control [disabledControl]="item.getRawValue().grondslagDesinvestering !== null"
                                                [label]="i === 0 ? 'Recht op KIA?' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-125"
                                                formControlName="claimKIA"
                                                id="claimEKIA-{{i}}"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-select-form-control [disabledControl]="item.getRawValue().grondslagDesinvestering !== null"
                                                [label]="i === 0 ? 'Recht op EIA?' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-125"
                                                formControlName="claimEIA"
                                                id="claimEIA-{{i}}"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-select-form-control [disabledControl]="item.getRawValue().grondslagDesinvestering !== null"
                                                [label]="i === 0 ? 'Recht op MIA?' : ''"
                                                [options]="optionsJaNee"
                                                class="custom-input-125"
                                                formControlName="claimMIA"
                                                id="claimMIA-{{i}}"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   [class]="i === 0 ? 'pt-3 custom-input-150' : 'custom-input-150'"
                                   [disabled]="!item.getRawValue().claimKIA && !item.getRawValue().claimEIA && !item.getRawValue().claimMIA"
                                   icon="plus"
                                   type="secondary">
                Meer gegevens
              </snelstart-ui-button>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [disabledControl]="item.getRawValue().claimKIA || item.getRawValue().claimEIA || item.getRawValue().claimMIA"
                                                [label]="i === 0 ? 'Desinvestering' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="grondslagDesinvestering"
                                                id="grondslagDesinvestering-{{i}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [disabledControl]="item.getRawValue().grondslagDesinvestering === null"
                                                [label]="i === 0 ? '% Desinv.bijt.' : ''"
                                                [showAllDecimals]="true"
                                                align="right"
                                                class="me-1 custom-input-125"
                                                formControlName="percentageInvesteringsaftrek"
                                                id="percentageInvesteringsaftrek-{{i}}"
                                                placeholder="n.v.t."
                                                prefix="%">
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteInv"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button"
                           icon="plus"
                           type="link">(Des)investering toevoegen
      </snelstart-ui-button>
    }
  </form>
} @else {
  <p>Er zijn geen ondernemingen gevonden.</p>
}

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="specificatie" size="lg"
                                title="Specificatie investering">
  <snelstart-ui-dialog-body>
    <form [formGroup]="formGroup">
      @if (investeringen.length > 0) {
        <div formArrayName="investeringen" (change)="saveForm()">
          @for (item of investeringen.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (i === this.index) {
                <snelstart-ui-date-form-control class="custom-input-250"
                                                formControlName="datumIngebruikname"
                                                id="datumIngebruikname-{{i}}"
                                                label="Datum ingebruikname"
                                                placeholder="dd-mm-jjjj"
                >
                </snelstart-ui-date-form-control>
                @if (item.getRawValue().claimKIA) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="investeringsbedragKIA"
                                                    id="investeringsbedragKIA-{{i}}"
                                                    label="Investeringsbedrag voor de KIA"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="aandeelInInvesteringsBedrag"
                                                    label="Aandeel in investeringsbedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                }
                @if (item.getRawValue().claimEIA) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="investeringsbedragEIA"
                                                    label="Investeringsbedrag voor de EIA"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-text-form-control class="custom-input-250"
                                                  formControlName="meldingsNummerEia"
                                                  label="Meldingsnummer EIA"
                  >
                  </snelstart-ui-text-form-control>
                }
                @if (item.getRawValue().claimMIA) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    align="right"
                                                    class="custom-input-250"
                                                    formControlName="investeringsbedragMIA"
                                                    label="Investeringsbedrag voor de MIA"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-text-form-control class="custom-input-250"
                                                  formControlName="meldingsNummerMia"
                                                  label="Meldingsnummer MIA"
                  >
                  </snelstart-ui-text-form-control>
                  <snelstart-ui-select-form-control [options]="miaLetter"
                                                    class="custom-input-250"
                                                    formControlName="miaLetter"
                                                    label="Meldingsletter"
                  >
                  </snelstart-ui-select-form-control>
                }
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="reedsBetaaldDoorAangever"
                                                  label="Al betaald in boekjaar"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              }
            </div>
          }
        </div>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button btn-x class="me-2" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary">Akkoord</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
